<template>
  <div class="yda-new-conversion-api-history-list">
    <table class="like-element-ui border">
      <thead>
        <tr>
          <th class="sticky-col" style="min-width: 170px">
            <div class="cell">API送信日時</div>
          </th>
          <th style="min-width: 150px">
            <div class="cell">アカウント名</div>
          </th>
          <th style="min-width: 150px">
            <div class="cell">プログラム名</div>
          </th>
          <th style="min-width: 180px">
            <div class="cell">コンバージョン名</div>
          </th>
          <th style="min-width: 180px">
            <div class="cell">タグID</div>
          </th>
          <th style="min-width: 150px">
            <div class="cell">スニペットID</div>
          </th>
          <th style="min-width: 115px">
            <div class="cell">API送信結果</div>
          </th>
          <th style="min-width: 300px">
            <div class="cell">エラーメッセージ</div>
          </th>
          <th style="min-width: 175px">
            <div class="cell">CV発生日時</div>
          </th>
          <th style="min-width: 100px">
            <div class="cell">報酬額</div>
          </th>
          <th style="min-width: 300px">
            <div class="cell">atid生成日時</div>
          </th>
          <th style="min-width: 180px">
            <div class="cell">atid</div>
          </th>
          <th style="min-width: 200px">
            <div class="cell">event_type</div>
          </th>
          <th style="min-width: 250px">
            <div class="cell">ly_su</div>
          </th>
          <th style="min-width: 250px">
            <div class="cell">ly_c</div>
          </th>
          <th style="min-width: 250px">
            <div class="cell">ly_r</div>
          </th>
          <th style="min-width: 350px">
            <div class="cell">UA</div>
          </th>
          <th style="min-width: 150px">
            <div class="cell">IP</div>
          </th>
          <th style="min-width: 80px">
            <div class="cell">再送</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in conversionApiHistoryList" :key="index">
          <td class="sticky-col">
            <div class="cell">{{ row.sendDatetime }}</div>
          </td>
          <td>
            <div class="cell">
              <span v-if="row.tools02TagData !== null && row.tools02TagData.tools02AccountData !== null">{{
                row.tools02TagData.tools02AccountData.accountName }}</span>
              <span v-else>-</span>
            </div>
          </td>
          <td>
            <div class="cell">
              <span v-if="row.reportData.tools02PromotionData === null">-</span>
              <span v-else>{{ row.reportData.tools02PromotionData.promotionName }}</span>
            </div>
          </td>
          <td>
            <div class="cell">
              <span v-if="row.tools02TagData !== null">{{ row.tools02TagData.name }}</span>
              <span v-else>-</span>
            </div>
          </td>
          <td>
            <div class="cell">{{ row.mediaTagId }}</div>
          </td>
          <td>
            <div class="cell">{{ row.ydaSnippetId }}</div>
          </td>
          <td>
            <div class="cell">
              <span v-if="row.eventReceived === true">成功</span>
              <span v-else>失敗</span>
            </div>
          </td>
          <td>
            <div class="cell">
              <el-input readonly v-model="row.errorMessage">
                <el-button @click="g_copyText(row.errorMessage)" slot="append" icon="el-icon-document-copy"></el-button>
              </el-input>
            </div>
          </td>
          <td>
            <div class="cell">
              <span v-if="row.adtasukaruIdCreatedAt === null">{{ row.eventDatetime }}</span>
              <span v-else>
                <span :class="row.eventDatetime < row.adtasukaruIdCreatedAt ? 'red' : ''">{{ row.eventDatetime }}</span>
              </span>
            </div>
          </td>
          <td>
            <div class="cell">{{ row.value }}</div>
          </td>
          <td>
            <div class="cell">
              <span v-if="row.adtasukaruIdCreatedAt === null">-</span>
              <span v-else>{{ row.adtasukaruIdCreatedAt }}</span>
            </div>
          </td>
          <td>
            <div class="cell">
              <span v-if="row.adtasukaruId === null">-</span>
              <span v-else>{{ row.adtasukaruId }}</span>
            </div>
          </td>
          <td>
            <div class="cell">{{ row.eventType }}</div>
          </td>
          <td>
            <div class="cell">
              <el-input readonly :value="row.lySu">
                <el-button @click="g_copyText(row.lySu)" slot="append" icon="el-icon-document-copy"></el-button>
              </el-input>
            </div>
          </td>
          <td>
            <div class="cell">
              <el-input readonly :value="row.lyC">
                <el-button @click="g_copyText(row.lyC)" slot="append" icon="el-icon-document-copy"></el-button>
              </el-input>
            </div>
          </td>
          <td>
            <div class="cell">
              <el-input readonly :value="row.lyR">
                <el-button @click="g_copyText(row.lyR)" slot="append" icon="el-icon-document-copy"></el-button>
              </el-input>
            </div>
          </td>
          <td>
            <div class="cell">
              <el-input readonly :value="row.userAgent">
                <el-button @click="g_copyText(row.userAgent)" slot="append" icon="el-icon-document-copy"></el-button>
              </el-input>
            </div>
          </td>
          <td>
            <div class="cell">{{ row.ipAddress }}</div>
          </td>
          <td>
            <div class="cell">
              <el-button @click="resendConversionEvent(row)" type="primary" size="mini">再送</el-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "yda-new-conversion-api-history-list",
  components: {},
  props: {
    conversionApiHistoryList: Array,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rt"]),
  },
  watch: {},
  methods: {
    resendConversionEvent(apiHistoryData) {
      console.log(apiHistoryData);

      //
      const promotionName =
        apiHistoryData.reportData.tools02PromotionData !== null
          ? apiHistoryData.reportData.tools02PromotionData.promotionName
          : "-";

      //
      const accountName =
        apiHistoryData.tools02TagData !== null && apiHistoryData.tools02TagData.tools02AccountData !== null
          ? apiHistoryData.tools02TagData.tools02AccountData.accountName
          : "-";

      //
      let confirmText = "";
      confirmText += `API送信日時: ${apiHistoryData.sendDatetime}\n`;
      confirmText += `アカウント名: ${accountName}\n`;
      confirmText += `プログラム名: ${promotionName}\n`;
      confirmText += `コンバージョン名: ${apiHistoryData.tools02TagData !== null ? apiHistoryData.tools02TagData.name : '-'}\n`;
      confirmText += `タグID: ${apiHistoryData.mediaTagId}\n`;
      confirmText += `スニペットID: ${apiHistoryData.ydaSnippetId}\n`;
      confirmText += `CV発生日時: ${apiHistoryData.eventDatetime}\n`;
      confirmText += `報酬額: ${apiHistoryData.value}\n`;
      confirmText += `atid: ${apiHistoryData.adtasukaruId || '-'}\n`;
      confirmText += `event_type: ${apiHistoryData.eventType}\n`;
      confirmText += `ly_su: ${apiHistoryData.lySu}\n`;
      confirmText += `ly_c: ${apiHistoryData.lyC}\n`;
      confirmText += `ly_r: ${apiHistoryData.lyR}\n`;
      confirmText += `\n`;
      confirmText += `のAPIを再送信します。よろしいですか？`;

      //
      let payload = {
        confirmText: confirmText,
        apiHistoryData: apiHistoryData,
      };
      this.$emit("resendConversionEvent", payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.yda-new-conversion-api-history-list {
  overflow: scroll;

  .width-max-cover {
    table {
    }
  }
}
</style>
